"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignOutButton = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../utils");
const withClerk_1 = require("./withClerk");
exports.SignOutButton = (0, withClerk_1.withClerk)((_a) => {
    var { clerk, children } = _a, props = tslib_1.__rest(_a, ["clerk", "children"]);
    const { signOutCallback, signOutOptions } = props, rest = tslib_1.__rest(props, ["signOutCallback", "signOutOptions"]);
    children = (0, utils_1.normalizeWithDefaultValue)(children, 'Sign out');
    const child = (0, utils_1.assertSingleChild)(children)('SignOutButton');
    const clickHandler = () => {
        return clerk.signOut(signOutCallback, signOutOptions);
    };
    const wrappedChildClickHandler = async (e) => {
        await (0, utils_1.safeExecute)(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = Object.assign(Object.assign({}, rest), { onClick: wrappedChildClickHandler });
    return react_1.default.cloneElement(child, childProps);
}, 'SignOutButton');
//# sourceMappingURL=SignOutButton.js.map